/* global __REELEVANT_NEW_SCRIPT_URL__ */
import window from 'window'
import document from 'document'
import globalThis from 'globalThis'

const mapping = {'5ef5b5ceb9e2270013fa60cb': '607ec73bd839000300105f29', '5e53fa5adf32ef00197ab712': '607ec73f1360000300516e2e', '57a32a503ac78e0f003e6713': '607ec741d839000300105f2b', '5b1657cfe9a83700125a813b': '607ec7431360000300516e31', '5880efb9718f7e00108285ac': '607ec7451360000300516e33', '5dce331069cd3c0019205375': '607ec748d839000300105f2f', '5bc9c5b3b1f638001bd02cf5': '607ec749d839000300105f31', '5d0a3081636cab00199aa22b': '607ec74a1360000300516e38', '5a9594a203849d001dfb3fda': '607ec74cd839000300105f34', '5c61e40ab1de660013337d04': '607ec74d1360000300516e3b', '5d2836208f025b00135e8f3c': '607ec74e1360000300516e3e', '5d8a02b55903780019fe70ee': '607ec74f1360000300516e40', '5bb4d6d52a5b0a0012cdc78a': '607ec750d839000300105f37', '5f0b4349692b5f00190f18fe': '607ec7511360000300516e44', '600e9f576a9bcb00107c47f6': '607ec7521360000300516e46', '60646c02c206fe0019d24e12': '609bc4f74e3c000300131110', '5a01d8f147ce130018b8e279': '609bc534f46c000300b29dcf', '60ba3fbb5a12a600107e3e74': '60c0c8b83b57000300702aa5'}

const instance = {
  _key: window.reel._key,
  companyId: window.reel._key,
  datasourceId: mapping[window.reel._key],
  queue: [],
  event: function (name, data) {
    this.queue.push([name, data])
  },
  identify: function (id) {
    this.event('identify', id)
  }
}

// patch global so that event can be sent with the new script
if (window.reel) {
  window.reel.companyId = window.reel._key
  window.reel.datasourceId = mapping[window.reel._key]
  if (window.reel._runQueue !== window.reel.queue) {
    window.reel.queue = window.reel._runQueue ? window.reel._runQueue.map(event => ([event.name, event.data])) : []
    window.reel._runQueue = window.reel.queue
  }
} else if (globalThis.reel) {
  window.reel = instance
  window.reel.queue = globalThis.reel._runQueue ? globalThis.reel._runQueue.map(event => ([event.name, event.data])) : []
  globalThis.reel._runQueue = window.reel.queue
} else {
  window.reel = instance
}

const script = 'script'
const firstScriptTag = document.getElementsByTagName(script)[0]
const element = document.createElement(script)
element.src = __REELEVANT_NEW_SCRIPT_URL__.replace(/{datasourceId}/g, window.reel.datasourceId).replace(/{companyId}/g, window.reel.companyId)
element.type = 'text/javascript'
element.async = true
firstScriptTag.parentNode.insertBefore(element, firstScriptTag)
